import { render, staticRenderFns } from "./programme.vue?vue&type=template&id=6512be6c&"
import script from "./programme.vue?vue&type=script&lang=js&"
export * from "./programme.vue?vue&type=script&lang=js&"
import style0 from "./programme.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports